import { StyleSheet } from 'react-native'
import { pageContainerStyle } from '../../common.style'

export default StyleSheet.create({
    container: {
        ...pageContainerStyle,
        backgroundColor: '#ffffff',
        paddingHorizontal: 16,
        paddingTop: 20,
        height: '100%',
    },
    dialogContainer: {
        width: "100%",
        justifyContent:'center',
        alignItems: 'center',
        alignSelf: 'center',
        gap: 10
    },
    pageSubtitle: {
        fontSize: 16,
        color: '#6b7280',
        textAlign: 'center',
        marginBottom: 24,
    },
    subContainer: {
        flex: 1,
    },
    title: {
        fontSize: 16,
        fontWeight: '600',
        color: '#374151',
    },
    subtitle: {
        fontSize: 14,
        fontWeight: '600',
        color: '#4b5563',
    },
    cardContent: {
        gap: 5,
        borderLeftWidth: 2,
        paddingLeft: 12,
    },
    card: {
        backgroundColor: '#FFF',
        borderRadius: 15,
        padding: 18,
        shadowColor: '#000',
        shadowOpacity: 0.06,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
        elevation: 2,
        width: 300,
        height: 150,
        gap: 5
    },
    dialogCard: {
        borderRadius: 10,
        width: '100%',
        padding: 10,
        borderWidth: 1,
        borderColor: '#eee9ee',
    },
    buttonsRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "center",
        gap: 10,
        padding: 5,
        width: "100%"
    },
    buttonAccept:{
        backgroundColor: '#3b82f6',
        padding: 10,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: "40%"
    },
    buttonRefuse: {
        backgroundColor: '#ef4444',
        padding: 10,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: "40%"
    },
    buttonPrimary: {
        flex: 1,
        backgroundColor: '#3b82f6',
        paddingVertical: 16,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonSecondary: {
        flex: 1,
        backgroundColor: '#ef4444',
        paddingVertical: 16,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonText: {
      color: 'white',
      fontSize: 14,
      fontWeight: 'bold',
    },
    sectionTitle: {
        fontSize: 12,
        fontWeight: '700',
        color: '#000000',
        marginVertical: 5,
        letterSpacing: 0.8,
        textTransform: 'uppercase',
    },
    secondaryText: {
        fontSize: 14,
        color: '#b8bdce',
    },
    reducedCardsListContainer: {
        maxHeight: 480,
        overflow: "hidden"
    },
    validationCardContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: 10,
    },
    voirToutContainer: {
        justifyContent: 'flex-end',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        padding: 8
    },
    voirToutText: {
        fontSize: 16,
        fontWeight: 600,
        color: '#D6330D'
    },
    pastilleFleche: {
        borderRadius: '100%',
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: "#E80C0C30"
    },
    commentaireInput: {
        borderWidth: 1,
        borderColor: '#d1d5db',
        borderRadius: 8,
        padding: 12,
        fontSize: 16,
        color: '#374151',
        backgroundColor: '#f9fafb',
        textAlignVertical: 'top',
        minHeight: 80,
        width: "100%"
    },
    inline: {
        flexDirection: 'row',
        justifyContent: "space-between",
    },
    soldeContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%',
        alignItems: 'center',
    },
    soldeElement: {
        alignItems: "center",
    }
})
